import { writable } from "svelte/store";

export const apiToken = writable("");
